const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFreelancer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 5928",
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.345,
    height: 99.323,
    viewBox: "0 0 113.345 99.323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6777",
    d: "M106.7 82.665a3.317 3.317 0 0 1-3.321 3.306h-20.3V56.529c0-.367-.016-.731-.04-1.092a9.981 9.981 0 0 1 2.605-.346h11.098a9.951 9.951 0 0 1 9.962 9.917zm-30.26 3.306H36.9V56.529a9.951 9.951 0 0 1 9.962-9.917h19.616a9.951 9.951 0 0 1 9.962 9.917zM30.263 56.53v29.441H9.962a3.317 3.317 0 0 1-3.321-3.306V65.008a9.951 9.951 0 0 1 9.959-9.917h11.1a9.97 9.97 0 0 1 2.605.346c-.024.362-.04.725-.04 1.092zm66.478-8.051H85.647a16.626 16.626 0 0 0-4.363.583A16.625 16.625 0 0 0 66.478 40H46.867a16.625 16.625 0 0 0-14.8 9.062 16.622 16.622 0 0 0-4.363-.583H16.6A16.585 16.585 0 0 0 0 65.008v17.657a9.951 9.951 0 0 0 9.962 9.918h93.421a9.951 9.951 0 0 0 9.962-9.918V65.008a16.585 16.585 0 0 0-16.6-16.529z",
    transform: "translate(0 6.74)",
    style: {
      fill: "#f6b119",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6778",
    d: "M20.606 38.638a8.031 8.031 0 1 1 8.031-8.031 8.041 8.041 0 0 1-8.031 8.031zm0-22.638a14.606 14.606 0 1 0 14.607 14.606A14.623 14.623 0 0 0 20.606 16z",
    transform: "translate(1.011 2.696)",
    style: {
      fill: "#f6b119",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6779",
    d: "M50.865 33.036a13.172 13.172 0 1 1 13.171-13.171 13.186 13.186 0 0 1-13.171 13.171zm0-33.036a19.865 19.865 0 1 0 19.864 19.865A19.887 19.887 0 0 0 50.865 0z",
    transform: "translate(5.224)",
    style: {
      fill: "#f6b119",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6780",
    d: "M80.606 38.638a8.031 8.031 0 1 1 8.031-8.031 8.041 8.041 0 0 1-8.031 8.031zm0-22.638a14.606 14.606 0 1 0 14.607 14.606A14.623 14.623 0 0 0 80.606 16z",
    transform: "translate(11.121 2.696)",
    style: {
      fill: "#f6b119",
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreelancer);
export default __webpack_public_path__ + "static/media/freelancer.97d95910f39f0e2d0eb87a65a1a873e0.svg";
export { ForwardRef as ReactComponent };